/**
 * A function to change nested property of an object
 * @param {object} input
 * @param {object} input.obj - source object
 * @param {string} input.property - nested property(each property should be separated using dot)
 * @param {*} input.value - value which will be assigned to property of the source object
 * @returns {undefined}
 */
export default function deepSetObjectProperty({ obj, property, value }) {
  const splittedProperty = property.split('.');
  let lastPropertyObject = obj;

  for (let i = 0; i < splittedProperty.length - 1; i++) {
    const currentProperty = splittedProperty[i];
    if (!(currentProperty in lastPropertyObject))
      throw new Error(
        `Property ${currentProperty} not found on source object!`,
      );

    lastPropertyObject = lastPropertyObject[currentProperty];
  }

  const lastProperty = splittedProperty[splittedProperty.length - 1];
  lastPropertyObject[lastProperty] = value;
}
